import React from "react";

import { useFormikContext } from "formik";
import { ImageEngineEnum } from "../../../../../enums/imageEngine";
import useUser from "../../../../../hooks/useUser";
import { Template } from "../../../../../models";
import TemplateContainer from "../../common/TemplateContainer";

import InfoTooltip from "../../../../../components/common/InfoTooltip";
import ImageEngineSelector from "./ImageEngineSelector";
import ImageExcludeFacesToggle from "./ImageExcludeFacesToggle";
import ImageExcludeTextToggle from "./ImageExcludeTextToggle";
import ImageSizeSelector from "./ImageSizeSelector";
import ImageStyleSelector from "./ImageStyleSelector";
import ImageToneSelector from "./ImageToneSelector";

const ImageSettings = () => {
  const { user } = useUser();
  const { values } = useFormikContext<Partial<Template>>();
  const includeImage = !!values?.includeImage;

  if (!includeImage) return null;

  return (
    <div className="animate-fadeIn">
      <TemplateContainer>
        <div className="space-y-6">
          {user?.isSuper && <ImageEngineSelector />}
          <ImageSizeSelector />
          <ImageStyleSelector />
          <ImageToneSelector />
          {values?.imageEngineId === ImageEngineEnum.RECRAFT_V3 && (
            <div>
              <h3 className="mb-2 tracking-wide font-medium leading-6 text-gray-900 text-xs flex items-center gap-2 uppercase">
                Image Options
                <InfoTooltip
                  id="image_options"
                  tooltip="These options help influence the image generator but are not guaranteed exclusions."
                />
              </h3>
              <div className="space-y-4">
                <ImageExcludeTextToggle />
                <ImageExcludeFacesToggle />
              </div>
            </div>
          )}
        </div>
      </TemplateContainer>
    </div>
  );
};

export default ImageSettings;
